/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  SearchRoutinesMutationRequest,
  SearchRoutinesMutationResponse,
  SearchRoutines401,
  SearchRoutines403,
} from '../types/SearchRoutines.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getSearchRoutinesUrl() {
  const res = { method: 'POST', url: `/routines/search` as const };
  return res;
}

/**
 * @summary Search routines
 * {@link /routines/search}
 */
export async function searchRoutines(
  data: SearchRoutinesMutationRequest,
  config: Partial<RequestConfig<SearchRoutinesMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    SearchRoutinesMutationResponse,
    ResponseErrorConfig<SearchRoutines401 | SearchRoutines403>,
    SearchRoutinesMutationRequest
  >({ method: 'POST', url: getSearchRoutinesUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
